import { buildRequest } from '.';

class general {
  getVersion = () => (
    buildRequest('GET', '/system/general-information')
  )

  whoAmI = () => (
    buildRequest('GET', '/whoami')
  )

  getLicenseToken = () => (
    buildRequest('GET', '/system/license-token')
  )

  updateLicenseToken = (newToken: string) => (
    buildRequest('PUT', '/system/update-license-token', { token: newToken })
  )
}

export default general;
